
<div fxLayout="row" fxLayoutAlign="space-between center">
  <span mat-dialog-title class="title text-hard-blue">Abrir Chamado</span>
  <app-call-files
    (filesIncuded)="filesIncuded($event)"
  ></app-call-files>
</div>

<div mat-dialog-content style="overflow: hidden;">
  <mat-form-field fxFill appearance="outline">
    <mat-select [(ngModel)]="type">
      <mat-option value="I">Incidente</mat-option>
      <mat-option value="D">Defeito</mat-option>
      <mat-option value="P">Problema</mat-option>
      <mat-option value="A">Requisição de alteração</mat-option>
    </mat-select>
    <mat-label>Tipo do Chamado</mat-label>
    <mat-hint>* Requerido</mat-hint>
  </mat-form-field>

  <div>
    <ckeditor
      fxFill
      [config]="{
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'undo',
          'redo'
        ]
      }"
      [editor]="entryEditor"
      [(ngModel)]="description"
    ></ckeditor>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button [disabled]="saving" mat-raised-button color="warn" mat-dialog-close>Cancelar</button>
  <button [disabled]="saving" mat-raised-button color="primary" (click)="createCall()">Abrir Chamado</button>
</div>
